export const stackParse = (data) => {
  const stack = [];
  data.stack.forEach((element) => {
    const ele = {
      file: element.file,
      codeArray: [],
    };
    if (element.content) {
      const lines = element.content.split('\n');

      // eslint-disable-next-line no-nested-ternary, max-len
      // const start = element.line > 5 ? element.line - 5 : element.line;

      // eslint-disable-next-line no-nested-ternary, max-len
      const start = element.line > 5 ? element.line - 5 : element.line - 1;

      const contents = lines.slice(start, element.line + 5);

      contents.forEach((e, i) => {
        const lineNum = start + i + 1;
        const line = {
          line: lineNum,
          message: e,
          // heightLight: i + 1 === 5,
          heightLight: lineNum === element.line,
        };
        ele.codeArray.push(line);
      });
    }
    stack.push(ele);
  });
  return stack;
};
